import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import { useCsCfgObject } from "@plansoft-configuration-renderer/framework";
import { DebugColor } from "./DebugColor";
import { useShowDebugGroups } from "./DebugOptions";
import { DebugItemPopover } from "./DebugPopover";
import { DebugType } from "./DebugType";
export function GroupDebug(props) {
    var _a;
    const { id } = props;
    const { attributeGroups } = useCsCfgObject();
    const group = (_a = (attributeGroups !== null && attributeGroups !== void 0 ? attributeGroups : []).find((group) => group.id === id)) !== null && _a !== void 0 ? _a : {
        id: id,
    };
    return _jsx(GroupDebugDebugDisplay, { group: group });
}
export function GroupDebugDebugDisplay(props) {
    var _a;
    const showDebug = useShowDebugGroups();
    if (!showDebug) {
        return _jsx(Fragment, {});
    }
    const { group, chipSx, wrapperSx = {} } = props;
    return (_jsx(Box, { sx: wrapperSx, children: _jsx(DebugItemPopover, { item: group, color: DebugColor.Groups, type: DebugType.Groups, title: (_a = group.id) !== null && _a !== void 0 ? _a : "", chipSx: chipSx }) }));
}
//# sourceMappingURL=GroupDebug.js.map